import { combineReducers } from 'redux'
import waiverForms from './waiverForms'
import weekReservationsForm from './weekReservationsForm'
import eciForm from './eciForm'

const formsReducer = combineReducers({
  waiverForms,
  weekReservationsForm,
  eciForm
})

export default formsReducer
